(async () => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!Array.prototype.toSorted) {
    await import('core-js/actual/array/to-sorted');
  }
})();
